import { LinkToStacked } from 'react-stacked-pages-hook';
import { Link } from 'gatsby';
import * as React from 'react'

export default { LinkToStacked, Link, React }